// extracted by mini-css-extract-plugin
export default {"layout":"Index_layout__2QZc3","hasMaxWidth":"Index_hasMaxWidth__I7JKo","header":"Index_header__mPQUe"};